/* eslint-disable zeffy-linter-frontend/no-classname-prop -- legacy baseline (pre-rule); remove when these are migrated */
import { FC } from "react";

import { formatSmartNarrowCurrencyFromCents, getCurrencyFromCountry } from "@simplyk/common";

import { useFormV2Context } from "../../contexts/FormV2Context";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { useTranslate } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { usePreviewContext } from "@/features/LiveFormEditor/LivePreview/contexts/PreviewContext";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useIsGhostPreview } from "@/features/LiveFormEditor/LivePreview/useIsGhostPreview";
import {
  FormInfobox,
  FormInfoboxRichIconSubtleClassName,
  FormInfoboxRichIconClassName,
} from "@/forms-design-system/FormInfobox";

export const GenerateReceiptInfobox: FC = () => {
  const { isPreview } = usePreviewContext();
  const { displayGenerateReceipt, eligibleAmountTotal, formCountry } = useFormV2Context();
  const isGhostPreview = useIsGhostPreview("FormV2TaxReceiptsBanner");
  const { isoLocale } = useLocaleContext();
  const { t } = useTranslate();

  if (isPreview && !isGhostPreview) {
    return null;
  }

  if (!displayGenerateReceipt) {
    return null;
  }

  const currency = getCurrencyFromCountry(formCountry);
  const amount = formatSmartNarrowCurrencyFromCents(eligibleAmountTotal, { locale: isoLocale, currency });

  // We'll inline the svg in order to set a different branded fill color on the different elements
  const inlineSvg = (
    <svg className={FormInfoboxRichIconClassName} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        className={FormInfoboxRichIconSubtleClassName}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.85208 12.6484H20.9688C21.8688 12.6484 22.6021 11.9151 22.6021 10.9984V8.28177C22.6021 7.38177 21.8688 6.64844 20.9688 6.64844H4.85208C3.95208 6.64844 3.21875 7.38177 3.21875 8.28177V11.0151C3.21875 11.9151 3.95208 12.6484 4.85208 12.6484ZM21.4521 23.0317H24.5187C24.8854 23.0317 25.1854 22.7317 25.1854 22.3651C25.1854 21.9984 24.8854 21.6984 24.5187 21.6984H21.4521C21.0854 21.6984 20.7854 21.9984 20.7854 22.3651C20.7854 22.7317 21.0854 23.0317 21.4521 23.0317Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3339 28.3646C17.5339 28.4979 17.7505 28.5646 17.9672 28.5646C18.1839 28.5646 18.4005 28.4979 18.6339 28.3646L20.4839 27.1146L22.3339 28.3646C22.7172 28.6313 23.2172 28.6313 23.6005 28.3646L25.4505 27.1146L27.3672 28.3979C27.6005 28.5646 27.9172 28.5813 28.1839 28.4479C28.4339 28.3146 28.6005 28.0479 28.6005 27.7479V6.01458C28.6005 4.49792 27.3672 3.28125 25.8672 3.28125H10.1005C8.58385 3.28125 7.36719 4.51458 7.36719 6.01458V27.7646C7.36719 28.0479 7.51719 28.3313 7.78385 28.4646C8.03385 28.5979 8.35052 28.5813 8.60052 28.4146L10.5005 27.1313L12.3672 28.3646C12.7505 28.6313 13.2505 28.6313 13.6339 28.3646L15.4839 27.1146L17.3339 28.3646ZM16.1005 25.9479C15.9172 25.8146 15.6839 25.7479 15.4672 25.7479C15.2505 25.7479 15.0339 25.8146 14.8172 25.9313L12.9672 27.1813L11.1172 25.9313C10.7339 25.6646 10.2339 25.6646 9.85052 25.9313L8.68385 26.7313V6.01458C8.68385 5.23125 9.31719 4.61458 10.0839 4.61458H25.8172C26.6005 4.61458 27.2172 5.24792 27.2172 6.01458V26.7479L26.0339 25.9479C25.6505 25.6812 25.1505 25.6812 24.7672 25.9479L22.9172 27.1979L21.0672 25.9479C20.6839 25.6812 20.1839 25.6812 19.8005 25.9479L17.9505 27.1979L16.1005 25.9479ZM12.0839 16.9479C12.0839 17.2813 12.2339 17.4979 13.2005 17.8979C14.4172 18.3979 14.9339 19.0313 14.9339 19.9813C14.9339 20.8979 14.3339 21.6479 13.3839 21.8979C13.3505 21.9146 13.3172 21.9479 13.3172 21.9813V22.4813C13.3172 22.7813 13.0672 23.0313 12.7672 23.0313C12.4505 23.0313 12.2005 22.7813 12.2005 22.4813V22.0646C12.2005 22.0146 12.1839 21.9813 12.1339 21.9813C11.7339 21.9313 11.3339 21.8146 11.0172 21.6646C10.7672 21.5479 10.6339 21.2479 10.7339 20.9813L10.7672 20.8979C10.8172 20.7479 10.9339 20.6313 11.0839 20.5646C11.2172 20.5146 11.3839 20.5146 11.5339 20.5813C11.7672 20.6813 12.1339 20.8146 12.5839 20.8146C13.1672 20.8146 13.5672 20.498 13.5672 20.0479C13.5672 19.6313 13.2839 19.3313 12.5672 19.0479C11.6172 18.6813 10.7339 18.1813 10.7339 17.0646C10.7339 16.198 11.3005 15.4979 12.2172 15.2479C12.2505 15.2313 12.2839 15.1979 12.2839 15.1646V14.6979C12.2839 14.3979 12.5339 14.1479 12.8339 14.1479C13.1339 14.1479 13.3839 14.3979 13.3839 14.6979V15.0813C13.3839 15.1313 13.4172 15.1646 13.4672 15.1646C13.7672 15.1979 14.0505 15.2646 14.3005 15.3813C14.5839 15.4979 14.7005 15.7979 14.6005 16.0813L14.5672 16.1479C14.5005 16.2979 14.4005 16.4146 14.2505 16.4813C14.1172 16.5479 13.9672 16.5479 13.8339 16.4813C13.5672 16.3646 13.2505 16.2979 12.9339 16.2979C12.3005 16.2979 12.0839 16.6313 12.0839 16.9479Z"
      />
    </svg>
  );

  return (
    <FormInfobox
      icon={inlineSvg}
      title={t("donationForm", eligibleAmountTotal ? "ticketingGenerateReceipt" : "donationGenerateReceipt", {
        amount,
      })}
      components={{
        icon: {
          size: "large",
        },
      }}
      sx={{ opacity: isGhostPreview ? GHOST_PREVIEW_OPACITY : 1 }}
    />
  );
};
